const clientCommission = import.meta.env.VITE_CLIENT_COMMISSION
const providerCommsion = import.meta.env.VITE_PROVIDER_COMMISSION
import { termOfUseEs } from './termOfUse_es.js'
import { faqEs } from './faq_es.js'
import { whatMovesUsEs } from './whatMovesUs_es.js'
import { privacyPolicyEs } from './privacyPolicy_es.js'
import { textMessagePolicyEs } from './textMessagePolicy_es.js'
import { legalAgreementsContactEs } from './legalAgreementsContact_es.js'
export const spanishTranslation = {
    "footer_phoneLabel": "Teléfono: {{phone}}",
    "footer_call": "Llamar",
    "footer_copy": "Copiar",
    "myProfile": "Mi perfil",
    "panel": "Panel",
    "messages": "Mensajes",
    "ClientGuidance":"Centro de Orientación — Clientes",
    "ProviderGuidance":"Orientación para proveedores",
    "providerGuidance_tab1_title": "¿Qué se requiere para ser proveedor en Jandi?",
    "providerGuidance_tab1_intro": "Para activar tu perfil y comenzar a recibir solicitudes debes completar el proceso de validación profesional. Este proceso garantiza confianza, seguridad y estructura dentro de la plataforma.",
    "providerGuidance_tab1_mandatoryTitle": "¿Qué documentos son obligatorios para todos?",
    "providerGuidance_tab1_mandatory": "Todos los proveedores deben subir:\n✔ Certificado de Buena Conducta vigente\n✔ Identificación oficial con foto\nEstos documentos se utilizan únicamente para validación interna y no son visibles públicamente.",
    "providerGuidance_tab1_otherDocsTitle": "¿Qué otros documentos pueden requerirse?",
    "providerGuidance_tab1_otherDocs": "Dependiendo de tu categoría de servicio, pueden requerirse:\n• Licencias profesionales\n• Certificaciones técnicas\n• Permisos específicos\nSi tu categoría requiere licencia, tu perfil no será visible hasta que el documento sea aprobado.",
    "providerGuidance_tab1_profileTitle": "¿Qué información debe incluir mi perfil?",
    "providerGuidance_tab1_profile": "• Foto profesional (según Guía Oficial de Fotografía)\n• Descripción clara de experiencia\n• Categorías de servicio\n• Zona geográfica\n• Disponibilidad actualizada\n• Método de pago (Stripe y/o ATH Móvil)\nTiempo estimado de validación: 24–48 horas laborables.\nTu perfil no será visible hasta ser aprobado.",
    "providerGuidance_tab1_photoTitle": "¿Cómo debe ser mi foto de perfil?",
    "providerGuidance_tab1_photoDo": "Debe ser:\n✔ Retrato individual\n✔ Fondo claro y ordenado\n✔ Rostro visible y mirando a cámara\n✔ Buena iluminación\n✔ Imagen nítida",
    "providerGuidance_tab1_photoDont": "Evita:\n✘ Fotos grupales\n✘ Filtros\n✘ Gafas oscuras\n✘ Selfies informales\n✘ Fondos con desorden",
    "providerGuidance_tab1_photoNote": "Una imagen profesional aumenta la probabilidad de reserva.",
    "providerGuidance_tab2_title": "¿Cómo funciona Jandi cuando recibo una solicitud?",
    "providerGuidance_tab2_whereTitle": "¿Dónde veo nuevas solicitudes?",
    "providerGuidance_tab2_where": "Cuando un cliente solicita una cotización recibirás una notificación por correo electrónico y mensaje de texto. Podrás ver la solicitud dentro de la plataforma en:\nMensajes → Charlas\nDentro del chat podrás revisar los detalles del servicio solicitado y responder con tu propuesta.",
    "providerGuidance_tab2_timeTitle": "¿En cuánto tiempo debo responder?",
    "providerGuidance_tab2_time": "Se recomienda responder dentro de un periodo razonable para mostrar interés. Usualmente dentro de las 8 horas, al menos iniciar la conversación. Si no se inicia comunicación con el cliente dentro de ese tiempo, el sistema puede reasignar la solicitud a otro proveedor disponible para asegurar que el cliente reciba atención oportuna.\nResponder con rapidez aumenta la probabilidad de confirmación.",
    "providerGuidance_tab2_notifTitle": "¿Cómo recibo notificaciones?",
    "providerGuidance_tab2_notif": "Cada vez que ocurra alguna actividad relacionada con tu servicio recibirás notificaciones. Estas notificaciones se envían mediante:\n• correo electrónico\n• mensaje de texto\nPodrás recibir notificaciones cuando:\n• recibas una nueva solicitud\n• el cliente envíe un mensaje\n• se confirme un servicio\n• cambie el estado del servicio\n• ocurra una cancelación\nEstas alertas ayudan a mantener seguimiento del proceso.",
    "providerGuidance_tab2_coordTitle": "¿Dónde coordino el servicio?",
    "providerGuidance_tab2_coord": "La coordinación del servicio se realiza dentro de:\nMensajes\nAhí acuerdas con el cliente:\n• fecha\n• hora\n• alcance del trabajo\n• precio final",
    "providerGuidance_tab2_chatTitle": "¿Por qué es importante usar el chat interno?",
    "providerGuidance_tab2_chat": "El chat:\n• mantiene registro oficial del acuerdo\n• activa respaldo en caso de disputa\n• genera trazabilidad\n• protege tu reputación\nLas conversaciones fuera del sistema no activan protección dentro de la plataforma.",
    "providerGuidance_tab3_title": "¿Qué sucede paso a paso durante un servicio?",
    "providerGuidance_tab3_step1Title": "1. El cliente confirma el servicio",
    "providerGuidance_tab3_step1": "El cliente revisa tu propuesta, presiona Confirmar servicio e ingresa su método de pago. El monto se autoriza en ese momento, pero se procesa únicamente cuando el servicio se marque como completado dentro de la plataforma.",
    "providerGuidance_tab3_step2Title": "2. Marca “Llegué” (paso obligatorio)",
    "providerGuidance_tab3_step2": "Cuando llegues al lugar del servicio presiona:\nMarcar como llegado\nEste paso:\n• notifica al cliente\n• registra oficialmente tu llegada\n• activa el flujo del servicio dentro del sistema\n⚠️ Importante:\nSi el proveedor no marca “Llegué”, el sistema no habilita la opción “Trabajo completo” para el cliente. Por eso es importante marcar la llegada al comenzar el servicio.",
    "providerGuidance_tab3_step3Title": "3. Realiza el servicio",
    "providerGuidance_tab3_step3": "Ejecuta el trabajo según lo acordado en Mensajes.",
    "providerGuidance_tab3_step4Title": "4. El cliente marca “Trabajo completo”",
    "providerGuidance_tab3_step4": "Cuando el trabajo haya finalizado, el cliente presionará:\nTrabajo completo\nEste paso:\n• cierra oficialmente el servicio\n• activa el procesamiento del pago\n• registra la transacción\n• permite la reseña\nSi el cliente no marca “Trabajo completo”, el servicio permanece abierto en el sistema.",
    "providerGuidance_tab3_step5Title": "5. Crear disputa (si ocurre un problema)",
    "providerGuidance_tab3_step5": "Tanto el proveedor como el cliente tienen la opción de:\nCrear disputa\nEsto permite que el equipo de Jandi revise el caso utilizando:\n• historial del servicio\n• mensajes registrados\n• estados del servicio\nPor eso es importante mantener la comunicación dentro del sistema.",
    "providerGuidance_tab3_step6Title": "6. ¿Dónde veo mis pagos?",
    "providerGuidance_tab3_step6": "En:\nHistorial de pagos\nTambién puedes verificar detalles en tu panel de pagos.",
    "providerGuidance_tab4_title": "¿Cómo funcionan los pagos y cancelaciones?",
    "providerGuidance_tab4_whenPaidTitle": "¿Cuándo recibo el pago?",
    "providerGuidance_tab4_whenPaid": "El cliente autoriza el monto cuando confirma el servicio. El pago se procesa cuando el cliente marca “Trabajo completo” y se refleja entre 24-48 horas según el proceso con tu institución bancaria. Cuando Stripe genera la transacción recibirás un mensaje de texto.",
    "providerGuidance_tab4_clientCancelTitle": "¿Qué sucede si el cliente cancela dentro de 24 horas?",
    "providerGuidance_tab4_clientCancel": "Se aplicará una tarifa de cancelación conforme a la política de cancelación de Jandi.",
    "providerGuidance_tab4_providerCancel24Title": "¿Qué sucede si cancelo un servicio confirmado con más de 24 horas de anticipación?",
    "providerGuidance_tab4_providerCancel24": "No hay penalidad económica automática. Sin embargo, la cancelación se registra dentro del historial del proveedor.",
    "providerGuidance_tab4_providerCancelWithinTitle": "¿Qué sucede si cancelo dentro de las 24 horas del servicio?",
    "providerGuidance_tab4_providerCancelWithin": "La cancelación tendrá mayor impacto en tu historial dentro de la plataforma. Cancelaciones reiteradas pueden resultar en suspensión temporal de la cuenta.",
    "providerGuidance_tab4_reputationTitle": "¿Por qué impacta mi reputación?",
    "providerGuidance_tab4_reputation": "Porque Jandi funciona bajo compromiso programado. Cuando se confirma un servicio:\n• se bloquea agenda\n• se activa una relación contractual digital\nEl cumplimiento es parte del estándar profesional. Jandi protege el tiempo como un activo económico.",
    "providerGuidance_tab4_multiProviderTitle": "¿Puede el cliente solicitar a varios proveedores?",
    "providerGuidance_tab4_multiProvider": "Sí. El cliente puede enviar solicitudes a más de un proveedor para comparar propuestas. Responder rápido aumenta la probabilidad de confirmación.",
    "providerGuidance_tab5_title": "¿Qué estándares debo mantener como proveedor?",
    "providerGuidance_tab5_standards": "• Puntualidad\n• Comunicación profesional\n• Cumplimiento de acuerdos\n• Uso del sistema para coordinar servicios",
    "providerGuidance_tab5_platformOnly": "Solo los servicios gestionados dentro de la plataforma:\n• activan pago seguro\n• generan historial digital\n• permiten soporte en disputas\n• construyen reputación verificable",
    "providerGuidance_tab6_title": "¿Cuál es la relación legal y cómo se protege mi información?",
    "providerGuidance_tab6_contractor": "• Eres contratista independiente\n• No existe relación laboral con Jandi\n• Eres responsable de tus licencias y cumplimiento contributivo",
    "providerGuidance_tab6_payments": "Los pagos se procesan mediante Stripe. Las notificaciones por mensaje de texto se activan al aceptar las políticas legales.",
    "providerGuidance_tab6_docs": "Consulta los documentos completos en:\nwww.jandipr.com",
    "clientGuidance_tab1_title": "¿Cómo funciona Jandi?",
    "clientGuidance_tab1_intro": "Jandi conecta clientes con proveedores de servicios independientes en Puerto Rico. A través de la plataforma puedes:\n• solicitar cotizaciones\n• comunicarte con proveedores\n• confirmar servicios\n• autorizar pagos de forma segura\nCuando el servicio termina debes marcar Trabajo completo para cerrar la transacción.",
    "clientGuidance_tab1_stepsTitle": "¿Qué pasos sigo para contratar un servicio?",
    "clientGuidance_tab1_steps": "Solicita el servicio dentro de la plataforma.\nRevisa las propuestas recibidas en Mis propuestas.\nAbre la propuesta y revisa los detalles.\nPresiona Confirmar servicio.\nAutoriza el pago.\nEl servicio quedará programado dentro de la plataforma.",
    "clientGuidance_tab1_multiTitle": "¿Puedo solicitar cotización a varios proveedores?",
    "clientGuidance_tab1_multi": "Sí. Puedes enviar solicitudes a distintos proveedores para comparar:\n• precio\n• disponibilidad\n• experiencia\nEsto te permite elegir la opción que mejor se ajuste a tus necesidades.",
    "clientGuidance_tab2_title": "¿Cómo funcionan los pagos y las transacciones?",
    "clientGuidance_tab2_when": "Cuando confirmas un servicio, el pago se autoriza, pero no se cobra inmediatamente. El cargo se procesa únicamente cuando el servicio se marca como completado dentro de la plataforma. Esto protege tanto al cliente como al proveedor.",
    "clientGuidance_tab2_completeTitle": "¿Por qué debo marcar el servicio como completado?",
    "clientGuidance_tab2_complete": "Marcar Trabajo completo:\n• libera el pago al proveedor\n• cierra la transacción\n• habilita la reseña del servicio\nSi no se marca como completado, el sistema entiende que el servicio sigue abierto.",
    "clientGuidance_tab2_platformTitle": "¿Por qué debo pagar dentro de la plataforma?",
    "clientGuidance_tab2_platform": "Cuando el pago se realiza dentro de Jandi:\n• la transacción queda registrada\n• el pago se procesa de forma segura\n• existe historial del servicio\n• Jandi puede brindar apoyo si surge algún inconveniente\nSi el pago se realiza fuera de la plataforma, Jandi no puede garantizar respaldo ni asistencia.",
    "clientGuidance_tab3_title": "¿Cómo es el proceso con el proveedor durante un servicio?",
    "clientGuidance_tab3_step1Title": "1. El proveedor marca “Llegué”",
    "clientGuidance_tab3_step1": "Cuando el proveedor llegue al lugar del servicio marcará:\nMarcar como llegado\nEsto registra oficialmente la llegada del proveedor dentro del sistema.\n⚠️ Importante:\nHasta que el proveedor marque “Llegué”, el sistema no habilita la opción “Trabajo completo”.",
    "clientGuidance_tab3_step2Title": "2. Comunicación durante el servicio",
    "clientGuidance_tab3_step2": "Utiliza el chat dentro de Jandi para coordinar detalles del servicio y mantener el historial de la conversación. Si ambas partes lo desean, pueden intercambiar números telefónicos y comunicarse por otros medios de mutuo acuerdo. Sin embargo, Jandi solo puede brindar apoyo basado en la información registrada dentro de la plataforma.",
    "clientGuidance_tab3_step3Title": "3. Finalizar servicio: Trabajo completo",
    "clientGuidance_tab3_step3": "Cuando el trabajo esté terminado y conforme, presiona:\nTrabajo completo\nEsto:\n• cierra el servicio\n• libera el pago al proveedor\n• habilita la reseña del servicio\nSi el servicio no se marca como completado, la transacción permanecerá abierta en el sistema.",
    "clientGuidance_tab3_step4Title": "4. Crear disputa",
    "clientGuidance_tab3_step4": "Si surge algún inconveniente durante el servicio:\n• puedes comunicarte con el proveedor mediante el chat\n• puedes seleccionar Crear disputa\nEsto permite que el equipo de Jandi revise el caso utilizando la información registrada dentro de la plataforma.",
    "clientGuidance_tab4_title": "¿Qué ocurre si necesito cancelar o tengo un problema?",
    "clientGuidance_tab4_cancel24Title": "¿Qué ocurre si cancelo con más de 24 horas de anticipación?",
    "clientGuidance_tab4_cancel24": "Si cancelas con más de 24 horas de anticipación, no se aplicará ningún cargo.",
    "clientGuidance_tab4_cancelWithinTitle": "¿Qué ocurre si cancelo dentro de las 24 horas previas al servicio?",
    "clientGuidance_tab4_cancelWithin": "Si cancelas dentro de las 24 horas previas al servicio, se aplicará una tarifa de cancelación equivalente al 15% del valor total del servicio confirmado. Esta política protege el tiempo reservado por el proveedor.",
    "clientGuidance_tab4_problemTitle": "¿Qué ocurre si surge un problema con el servicio?",
    "clientGuidance_tab4_problem": "Si surge algún inconveniente:\n• puedes comunicarte con el proveedor mediante el chat\n• puedes crear una disputa dentro de la plataforma\nEl equipo de Jandi podrá revisar el caso y brindar apoyo según la información registrada en el sistema. Por eso es importante mantener la comunicación dentro de la plataforma.",
    "clientGuidance_tab5_title": "¿Cómo funciona mi cuenta dentro de Jandi?",
    "clientGuidance_tab5_smsTitle": "¿Por qué recibo notificaciones por mensaje de texto?",
    "clientGuidance_tab5_sms": "Jandi utiliza notificaciones para mantenerte informado sobre el estado del servicio. Podrás recibir avisos cuando:\n• se confirme una solicitud\n• recibas un nuevo mensaje\n• cambie el estado del servicio\n• el proveedor marque que está en camino o ha llegado\n• ocurra una cancelación\nEstas notificaciones ayudan a mantener seguimiento del servicio programado.",
    "clientGuidance_tab5_trustTitle": "¿Cómo sabemos que los proveedores son confiables?",
    "clientGuidance_tab5_trust": "Los proveedores que forman parte de Jandi pasan por un proceso de verificación que puede incluir:\n• verificación de identidad\n• certificado de buena conducta\n• licencias o certificaciones profesionales cuando aplican\nEsto ayuda a construir una comunidad más confiable.",
    "clientGuidance_tab5_reviewTitle": "¿Cómo dejo una reseña?",
    "clientGuidance_tab5_review": "Una vez completado el servicio podrás calificar tu experiencia y dejar comentarios sobre el trabajo realizado. Las reseñas ayudan a mantener estándares de calidad y orientan a otros clientes dentro de la plataforma.",
    "clientGuidance_tab5_behaviorTitle": "¿Qué comportamiento se espera dentro de la plataforma?",
    "clientGuidance_tab5_behavior": "Jandi promueve una comunidad basada en el respeto. Se espera que clientes y proveedores mantengan:\n• comunicación clara\n• trato cordial\n• uso responsable de la plataforma\nJandi se reserva el derecho de limitar o suspender cuentas en casos de uso indebido o comportamiento inapropiado.",
    "help": "Ayuda",
    "helpTitle": "Ayuda",
    "helpIntro": "Si necesitas apoyo del equipo de Jandi o tienes alguna consulta sobre el funcionamiento de la plataforma, puedes comunicarte con nosotros.",
    "helpSupportTitle": "Soporte del equipo Jandi",
    "helpEmail": "Correo electrónico:",
    "helpPhone": "Teléfono o mensaje de texto:",
    "helpDisputes": "Para asuntos relacionados con un servicio específico entre cliente y proveedor, utiliza el botón “Disputas” dentro del panel.",
    "helpMore": "También puedes encontrar más información y material educativo en:\nwww.jandipr.com y nuestras redes sociales.",
    "settings": "Configuración",
    "logout": "Cerrar sesión",
    "Buscar": "Buscar",
    "totalCharge":"Total a pagar",
    "C/R":"Cancelado/Reembolsado",
    "Buscando...": "Buscando...",
      "baseAmount": "Monto base",
  "commissionRate": "Tasa de comisión",
  "commissionAmount": "Monto de la comisión",
  "youWillReceive": "Recibirás",
  "confirmYourService": "Confirma tu servicio",
  "serviceAmount": "Monto del servicio",
  "experienceUpgrade": "Mejora de Experiencia",
  "businessGrowthUpgrade": "Mejora de Crecimiento Empresarial",
  "totalToPay": "Total a pagar",
  "yourGuaranteedEarnings": "Tus ingresos garantizados",
  "clientConfirmDescription": "Tu solicitud incluye una Mejora de Experiencia, que te ofrece una conexión rápida, segura y centralizada con profesionales verificados a través de Jandi.",
  "providerConfirmDescription": "Este trabajo incluye una Mejora de Crecimiento Empresarial, que fortalece tus herramientas operacionales, pagos seguros y visibilidad, ayudándote a atraer más clientes y hacer crecer tu negocio.",
  "clientConfirmFooter": "Esta mejora incrementa tu seguridad, tu comodidad y tu experiencia en toda la plataforma.",
  "clientConfirmVoucherNote": "Al pagar podrás ingresar un código de voucher. El descuento aplica solo a la Mejora de Experiencia (cargo de servicio), no al monto del servicio que recibe el proveedor.",
  "providerConfirmFooter": "Esta mejora impulsa tu crecimiento, reduce riesgos y te permite enfocarte en tu trabajo.",
  "confirmService": "Confirmar servicio",
  "submitProposal": "Enviar propuesta",
  'Resolve_&_Release_Payment':'Resolver y liberar pago',
  'Resolve_&_refund_payment':'Resolver y reembolsar pago',
  "governmentTax":"Impuesto gubernamental",
    "provider_platform_fee":"Tarifa de plataforma del proveedor",
    "client_platform_fee":"Tarifa de la plataforma del cliente",
     "CommissionNote":`Se cobrará una comisión del ${providerCommsion}% sobre el total de tus ganancias junto con este trabajo.`,
    "CommissionExample":"Ejemplo: El pago total del trabajo es $100. Se aplicará una comisión del 8%, por lo que tus ganancias netas serán de $92.",
     "CommissionNote17":`Se agregará una comisión de ${clientCommission}%, incluidos los impuestos, al monto total de este trabajo.`,
    "CommissionExample17":"Ejemplo: si el pago base del trabajo es $100, se aplicará una comisión del 17%, lo que eleva el cargo total a $117.",
    "CommissionAmount":"Importe total después de la comisión",  
    "offerMyService": "Ofrecer servicio",
    "iNeedAService": "Necesito servicio",
    "serviceArea": "Área de servicio",
    "accept&pay":"Aceptar propuesta y pagar",
    'CompleteJob':"Trabajo completo",
    "selectArea":"Seleccionar área(s)",
    "whereDoYouNeed":"¿Dónde lo necesitas?",
     "EssentialCompletedSuccessfully":"Detalles esenciales actualizados exitosamente",
    'alwaysAtHand':"Siempre a la mano",
    "GoToStripeOnboarding": "Ir a incorporación de Stripe",
    "selectServiceAreas": "Seleccione Área(s) de Servicio",
    "clean": "Limpiar",
    "servicesOffered": "¿Qué servicio necesitas?",
    "searchDescribeNeed": "Describe lo que necesitas (ej. 'Tutor de mates cerca de Condado los sábados')...",
    "searchDescribeWhatYouNeed": "Describe lo que necesitas",
    "searchByCategoryArea": "Por categoría y área",
    "searchPopular": "Popular:",
    "popularApCalculus": "Tutor de cálculo AP",
    "popularUrgentElectrical": "Reparación eléctrica urgente",
    "popularDeepCleaning": "Limpieza profunda del hogar",
    "popularGardenLandscaping": "Jardinería y paisajismo",
    "searchAiBadge": "IA",
    "selectServiceOffered": "¿Qué servicio necesitas?",
    "advancedSearch": "Búsqueda avanzada",
    "RequestQuote":"Solicitar Cotización",
    "requestAQuote":"Solicitar cotización",
    "sendQuoteRequest":"Enviar solicitud de cotización",
    "reviewQuoteRequest":"Revisar solicitud de cotización",
    "reviewAndConfirm":"Revisar y confirmar",
    "requestSummary":"Resumen de la solicitud",
    "serviceType":"Tipo de servicio",
    "selectedProfessionals":"Profesionales seleccionados",
    "professionalsWillRespond":"Estos profesionales revisarán tu solicitud y responderán con cotizaciones en breve.",
    "sendRequest":"Enviar solicitud",
    "quoteRequestNote":"Por favor revise su solicitud de cotización antes de enviarla al profesional.",
    "chooseMoreOptions": "Elegir más opciones",
    "sendingQuoteRequest":"Envío de solicitud de cotización",
    "continueToReview":"Continuar a revisión",
    "saveQuoteDetails":"Guardar detalles de cotización",
    "quoteDetailsSaved":"Detalles guardados. Elige proveedores y continúa.",
    "quoteDetails":"Detalles de la cotización",
    "selectProviders":"Proveedores",
    "selected":"Seleccionados",
    "maxProvidersSelected":"Puedes seleccionar hasta 3 proveedores.",
    "mustSelectProvider":"Selecciona al menos un proveedor.",
    "completeQuoteFormFirst":"Completa el formulario de cotización primero.",
    "noProfessionalsFound":"No se encontraron proveedores con estos filtros.",
    "autoSendNearby":"Envío automático a proveedores cercanos (hasta 3 dentro de 50 km)",
    "selectUpTo3Providers":"Seleccionar hasta 3 proveedores",
    "autoSendToNearbyProviders":"Envío automático a proveedores cercanos",
    "newServiceRequest":"Nueva solicitud de servicio",
    "fillDetailsToFindPros":"Completa los detalles a continuación para encontrar al mejor profesional para tu proyecto.",
    "findProfessionals":"Buscar profesionales",
    "chooseProfessionals":"Elegir profesionales",
    "selectUpTo3Experts":"Selecciona hasta 3 expertos para cotizar tu proyecto",
    "step1Of3Details":"PASO 1 DE 3: DETALLES Y SELECCIÓN",
    "requestDetails":"Detalles de la solicitud",
    "availableProfessionals":"Profesionales disponibles",
    "professionalsSelected":"Profesionales seleccionados",
    "chooseUpTo3ForQuotes":"Elige hasta 3 para cotizaciones",
    "estRate":"Tarifa est.",
    "addPhotosOptional":"Agregar fotos (opcional)",
    "requestSecureNote":"Tu solicitud es segura. Los profesionales están verificados y evaluados.",
    "chooseLocationOnMap":"Elegir ubicación en el mapa",
    "description_required":"Por favor agrega una descripción.",
    "something_went_wrong":"Algo salió mal.",
    "cannotSendProposalToYourself":"No puedes enviarte una propuesta a ti mismo.",
    "remote":"Remoto",
    "details":"Detalles",
    "providers":"Proveedores",
    "quoteConvertedTitle":"Cotización convertida en trabajo",
    "quoteConvertedToJob":"Esta solicitud de cotización fue aceptada y convertida en un trabajo. Ya no puedes editar una propuesta aquí.",
    "viewMyJobs":"Ver mis trabajos",
    "requestQuoteJobNotFound":"No se pudo cargar esta solicitud de cotización.",
    "proposalAcceptedReadOnly":"Esta propuesta fue aceptada. La edición está deshabilitada.",
    "proposalRejectedReadOnly":"Esta propuesta fue rechazada. La edición está deshabilitada.",
    "priceRange": "Rango de precios",
    "minimumQualification": "Calificación mínima",
    "budgetDetails":"Detalles del presupuesto",
    "enterBudgetDetails":"Mi rango de presupuesto es de $50-$100, busco precios competitivos...",
    "noDataAvailableAgainstFilters": "¡No hay datos disponibles para los filtros aplicados!",
    "otherRegionsProvidersAvailable": "Aquí hay proveedores de otras regiones.",
    "hireElectricianTrusted": "Contrata un ", 
    "trustedTask": "confiable para la tarea que necesitas.",
    "hireAProfessional": "CONTRATA A UN PROFESIONAL",
    "review": "Reseña",
    "login": "Ingresar",
    "bestProfessionalsNearYou": "Los mejores",
    "professionals": "profesionales",
    "nearYou": "cerca de ti",
    "noReviewsYet": "Este proveedor aún no tiene evaluaciones. ¡Sé el primero!",
    "viewProfile": "Ver perfil",
    "findUsAlsoHere": "Encuéntranos también aquí",
    "iWantToOfferMyServices": "Quiero ofrecer mis servicios",
    "availableServices": "Servicios Disponibles",
    "iNeedAServiceAgain": "Necesito un servicio",
    "discoverJandi": "Descubre Jandi",
    "copyright": " Jandi PR. Todos los derechos reservados.",
    "whatMovesUs": "Lo que nos mueve",
    "frequentlyAskedQuestions": "Preguntas frecuentes",
    "hireAProfessional": "CONTRATA UN PROFESIONAL",
    "aboutJandi": "En JANDI, hacemos que las conexiones sucedan de forma simple, segura y profesional. Nuestra visión es que quienes buscan un servicio puedan encontrar fácil, contratar seguro y resolver con JANDI, sin complicaciones. Nuestra misión es que quienes ofrecen sus servicios tengan un espacio confiable para trabajar, cobrar seguro y crecer con JANDI. Cada experiencia cuenta. Por eso, nuestro sistema de calificación fortalece la confianza, y la geolocalización permite conectar con alguien cerca, justo cuando lo necesitas. Nos mueve construir comunidad: un espacio donde el talento local, la eficiencia y la colaboración conviven para que todo funcione mejor, juntos.",
    "contactUs": "Háblanos",
    "contactDescription": "En Jandi estamos <strong>#SiempreALaMano.</strong> Queremos que tu experiencia sea simple, segura y sin complicaciones. Cuéntanos cómo podemos ayudarte y nuestro equipo te responderá lo antes posible.<br> Si necesitas apoyo, tienes una idea o quieres compartir tu feedback, escríbenos a <strong><a href=\"mailto:hola@jandipr.com\">hola@jandipr.com</a></strong>. ¡Nos encantaría escucharte!",
    "userEmail": "Correo Electronico de Usuario",
    "password": "Contraseña",
    "rememberMe": "Recuérdame",
    "forgotPassword": "¿Has olvidado tu contraseña?",
    "login": "Ingresar",
    "signup": "Registrarse",
    "register": "Registrarme",
    "registerAsCustomerOrServiceProvider": "Regístrate como cliente o proveedor de servicios",
    "imACustomer": "Soy un cliente",
    "imAServiceProvider": "Soy un proveedor de servicios",
    "doYouAlreadyHaveAnAccount": "¿Ya tienes una cuenta?",
    "signupToOfferYourServices": "Regístrate para ofrecer tus servicios",
    "signupAsCustomer": "Regístrate como cliente",
    "forgottenPassword": "Contraseña olvidada",
    "byEmail": "Por correo electrónico",
    "byPhone": "Por teléfono",
    "enterEmail": "Ingresa tu dirección de correo electrónico",
    "continue": "Continuar",
    "enterOtp": "Ingresa el código OTP",
    "otpSent": "Hemos enviado un código OTP al",
    "didNotReceiveCode": "¿No ha recibido el código?",
    "tryAgain": "Inténtalo de nuevo",
    "errorIncorrectCode": "Error: Código de verificación incorrecto",
    "send": "Enviar",
    "sendProposalToClient": "Enviar propuesta al cliente",
    "didNotReceiveEmail": "¿No ha recibido el correo electrónico?",
    "retryIn": "Vuelve a intentarlo en",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "phone": "Teléfono",
    "email": "Correo electrónico",
    "repeatPassword": "Repetir Contraseña",
    "areYouIndividualOrCompany": "¿Eres una persona individual o una empresa?",
    "select": "Seleccionar",
    "company": "Empresa",
    "individual": "Individual",
    "serviceCategory": "Categoría de Servicio",
    "selectCategory": "Seleccionar categoría",
    "homeCarePets": "Hogar\nCuidado\nMascotas",
    "selectServices": "Selecciona uno o varios servicios",
    "service": "Servicio",
    "services": "Servicios",
    "serviceListHome": "Plomería\nElectricidad\nLimpieza\nJardinería\nPintura\nReparaciones (Manitas)\nControl de plagas\nMantenimiento de techos\nMantenimiento de aire acondicionado\nMudanzas y transporte",
    "serviceListCare": "Cuidadores para Adultos Mayores\nCuidadores de Bebés\nTutoría\nOtro",
    "serviceListPets": "Baño y Estética\nCuidado de Mascotas en Casa\nHospedaje Temporal de Mascotas\nOtro",
    "regions": "Pueblo o region",
    "availability": "Disponibilidad",
    "selectAvailability": "Seleccione Disponibilidad",
    "mondayToFriday": "Lunes a Viernes",
    "saturdayToSunday": "Sábado a Domingo",
    "allDays": "Todos los días",
    "alreadyHaveAccount": "¿Ya tienes una cuenta?",
    "message": "Mensaje",
    "profileDetails": "Detalles del perfil",
    "sendProposal": "Enviar Propuesta",
    "ratingsAndReviews": "Evaluaciones de clientes",
    "ratingsAndReviewsSubtitle": "Servicios completados y verificados en jandi",
    "reviews": "Reviews",
    "description": "Descripción",
    "myProfile": "Mi perfil",
    "dashboard": "Cuadro de mando",
    "settings": "Configuración",
    "logout": "Cerrar sesión",
    "myProposals": "Mis trabajos",
    "providerMyProposals": "Mis propuestas",
    "providerMyProposalsNote": "Propuestas que enviaste para solicitudes de cotización de clientes.",
    "submittedDate": "Fecha de envío",
    "providerRequestQuotes": "Solicitudes de cotización",
    "providerRequestQuotesNote": "Cotizaciones que los clientes te enviaron. Ábrela para crear o actualizar tu propuesta.",
    "requestedDate": "Fecha de solicitud",
    "providerRequestQuoteDetail": "Solicitud de cotización",
    "noProviderRequestQuotesYet": "Aún no hay solicitudes de cotización en tu bandeja.",
    "noProviderProposalsYet": "Aún no has enviado ninguna propuesta.",
    "proposalStatus_awaiting": "Pendiente",
    "proposalStatus_submitted": "Enviada",
    "proposalStatus_accepted": "Aceptada",
    "proposalStatus_rejected": "Rechazada",
    "proposalStatus_converted": "Convertida",
    "create_proposal": "Crear propuesta",
    "edit_proposal": "Editar propuesta",
    "submit_proposal": "Enviar propuesta",
    "proposal_sent": "Propuesta guardada correctamente.",
    "request_quote_proposal_note": "Envía o actualiza tu propuesta para esta solicitud de cotización.",
    "request_quote_proposal_create_note": "Envía tu propuesta para esta solicitud de cotización.",
    "openChat": "Abrir chat",
    "cannotEditProposalForQuote": "Ya no puedes editar una propuesta para esta cotización.",
    "requestQuotes": "Solicitudes de cotización",
    "requestQuotesSubtitle": "Solicitudes de cotización abiertas esperando propuestas de profesionales.",
    "proposals": "Propuestas",
    "unauthorizedProposals": "No estás autorizado para ver estas propuestas.",
    "proposal_accepted": "Propuesta aceptada",
    "submitting": "Enviando…",
    "schedule": "Horario",
    "submitted": "Enviada",
    "accepted": "Aceptada",
    "noRequestQuotesYet": "Aún no hay solicitudes de cotización abiertas.",
    "awaitingProposals": "Esperando propuestas",
    "chatColumn": "Mensaje del proveedor",
    "proposedDate": "Fecha y hora propuesta",
    "transactionHistory": "Historial de transacciones",
    "adjustments": "Ajustes",
    "messages": "Mensajes",
    "jobInvitations": "Invitaciones de trabajo",
    "jobInvitation": "Invitación de trabajo",
    "paymentHistory": "Historial de pagos",
    "worker": "Trabajador",
    "client": "Cliente",
    "clientName": "Nombre del cliente",
    "hourlyRate": "Tarifa por hora",
    "totalHours": "Total de horas",
    "date": "Fecha",
    "status": "Estado",
    "currentJobStatus": "Estado Actual del Trabajo",
    "disputes": "Disputas",
    "dispute": "Disputa",
    "createDispute": "Crear Disputa",
    "reportIt":"Tengo un inconveniente — reportar",
    "confirmStatus":"Servicio confirmado — tu proveedor está al tanto",
    "disputeDetails": "Detalles de la Disputa",
    "issueType": "Tipo de Problema",
    "paymentIssue": "Problema de Pago",
    "workQuality": "Calidad del Trabajo",
    "behavior": "Comportamiento",
    "delayedPayout": "Pago retrasado",
    "other": "Otro",
    "disputeDescription": "Descripción",
    "disputeDescriptionPlaceholder": "Por favor describe el problema en detalle...",
    "uploadImages": "Subir Imágenes",
    "maxImages": "Máximo 5 imágenes",
    "submitDispute": "Enviar Disputa",
    "disputeCreated": "Disputa creada exitosamente",
    "disputeError": "Error al crear la disputa",
    "activeDisputeExists": "Ya existe una disputa activa para este trabajo. Por favor espera la resolución.",
    "disputeNotAllowed": "Solo puedes crear una disputa para trabajos que han comenzado.",
    "unauthorizedDispute": "Solo el dueño del trabajo o el trabajador asignado pueden crear una disputa.",
    "disputeStatus": "Estado de la Disputa",
    "open": "Abierta",
    "underReview": "En Revisión",
    "resolved": "Resuelta",
    "closed": "Cerrada",
    "resolutionNotes": "Notas de Resolución",
    "updateStatus": "Actualizar Estado",
    "disputeUpdated": "Estado de la disputa actualizado exitosamente",
    "noDisputes": "No se encontraron disputas",
    "filterByStatus": "Filtrar por Estado",
    "searchByJob": "Buscar por Trabajo",
    "createdBy": "Creada Por",
    "jobTitle": "Título del Trabajo",
    "jobId": "ID del Trabajo",
    "createdDate": "Fecha de Creación",
    "viewDispute": "Ver Disputa",
    "all": "Todos",
    "pending": "Pendiente",
    "waitingForPayment": "El cliente realizó el pago",
    "accept": "Aceptar",
    "reject": "Declinar propuesta",
    "confirmAccept": "¿Estás seguro de que quieres aceptar?",
    "confirmReject": "¿Estás seguro de que quieres rechazar?",
    "thisActionCannotBeUndone": "Esta acción no se puede deshacer.",
    "no": "No",
    "yes": "Sí",
    "attachment": "Adjunto",
    "arrivalLocation": "Ubicación de llegada",
    "noAttachments": "Sin archivos adjuntos",
    "viewInvitation": "Ver invitación",
    "paymentType": "Tipo de pago",
    "billingModel": "Facturación",
    "fixedPrice": "Precio fijo",
    "hourlyBreakdown": "${{rate}}/hr × {{hours}}h",
    "clientPaymentMethodLabel": "Pagaste con",
    "workerPaymentMethodLabel": "El proveedor recibe vía",
    "workerReceivesVia": "Recibes vía",
    "clientPaymentStatus": "Estado del pago",
    "paymentStatus_unpaid": "Sin pagar",
    "paymentStatus_pending": "Pendiente",
    "paymentStatus_confirmed": "Confirmado",
    "athPaymentPendingMessage": "Completa el pago en la app ATH Móvil para confirmar este servicio.",
    "payoutDelayedMessage": "Trabajo completado. El pago al proveedor puede retrasarse hasta que haya saldo disponible en la plataforma.",
    "paymentFlow": "Flujo de pago",
    "totalAmount": "Monto total",
    "markAsOnWay": "Marcar como en camino",
    "refund": "Reembolso",
    "startJob": "Iniciar trabajo",
    "confirmed": "Confirmado",
    "onTheWay": "En camino al servicio",
    "autoArrivalDetected": "Has llegado al lugar del servicio. Estado actualizado automáticamente.",
    "waitingForProviderArrival": "El proveedor está en camino — la llegada suele confirmarse automáticamente",
    "distanceToJob": "A {{distance}} de distancia",
    "confirmArrivalManually": "Confirmar llegada manualmente",
    "arrivalGpsUnavailable": "No se pudo confirmar la llegada. Verifica los permisos de ubicación o inténtalo de nuevo.",
    "autoArrivalEnabled": "La llegada se detectará automáticamente cuando estés dentro del rango",
    "gettingYourLocation": "Obteniendo tu ubicación…",
    'quoteRequestSent': 'Solicitud de cotización enviada exitosamente',
    "markAsArrived": "Marcar como llegado",
    "areYouSureMarkAsReached": "¿Estás seguro de que quieres mark as reached?",
    "arrivedWaitingConfirmation": "Llegado - esperando confirmación del cliente",
    "inProgress": "En progreso",
    "serviceInProgress": "Servicio en progreso",
    "workCompleted": "Trabajo finalizado - en espera de liberar el pago",
    "transactionId": "ID de transacción",
    "amount": "Monto",
    "backToLogin": "Volver a iniciar sesión",
    "PasswordDontMatch": "Las contraseñas no coinciden",
    "toastValidPhone": "Por favor ingrese un número de teléfono válido.",
    "toastValidEmail": "Por favor, introduce una dirección de correo electrónico válida.",
    "toastSelectRegionMunicipality": "Seleccione al menos una región/municipio.",
    "toastPasswordMin6": "La contraseña debe tener al menos 6 caracteres.",
    "toastPasswordStrongRequirements": "La contraseña debe tener al menos 6 caracteres, una mayúscula, una minúscula, un número y un carácter especial (!@#$%^&*).",
    "toastRegisterUserError": "Error al registrar el usuario. Por favor intente nuevamente.",
    "toastCustomServiceCreateFailed": "No se pudo crear el servicio personalizado.",
    "toastServiceCategoryCreateFailed": "No se pudo crear la categoría para el servicio.",
    "toastServiceOrCategoryCreateError": "Error creando servicio o categoría personalizada.",
    "toastUnverifiedEmail": "Aún no estás verificado. Por favor verifícate por correo electrónico primero.",
    "toastProfileUnderValidation": "Tu perfil está en validación; te avisaremos cuando esté activo—cualquier duda, contáctanos",
    "toastLoginSuccessful": "Inicio de sesión exitoso",
    "toastLoginSuccessfully": "Inicio de sesión realizado con éxito",
    "toastLogoutSuccess": "Has cerrado sesión correctamente.",
    "description/about": "Descripción/Acerca de",
    "workDetails": "Detalles del trabajo",
    "noDataFound": "No se encontraron datos",
    "certifications": "Certificaciones",
    "certificationsInstructionTitle": "🛡️ Documentación requerida para validación",
    "certificationsInstructionItem1": "Certificado de Buena Conducta (obligatorio)",
    "certificationsInstructionItem2": "Identificación oficial vigente (obligatorio)",
    "certificationsInstructionItem3": "Licencias/certificaciones (si aplica)",
    "certificationsInstructionPdfLimit": "PDF · Máx. 1MB por archivo",
    "certificationsInstructionApproval": "Tu perfil no será aprobado hasta completar esta sección.",
    "certificationsDisclaimer": "Los documentos cargados se utilizan únicamente para validación interna y no son visibles públicamente.",
    "skillsAndServices": "Habilidades y servicios",
    "regionAndService": "Región y Servicio",
    "regionAndServices": "Región y Servicios",
    "profilePhoto": "Foto de perfil",
    "uploadPhotoInstruction": "Haz clic en la imagen para subir una nueva foto de perfil <br/> Tamaño máximo de archivo: 10 MB",
    "personalInfo": "Datos personales",
    "phoneNumber": "Número de teléfono",
    "hourlyRateUsd": "Tarifa por hora (USD)",
    "cityLocation": "Ciudad/Ubicación",
    "physicalAddress": "Dirección física",
    "addressInfoOptional": "Información adicional de la dirección (opcional)",
    "addressNumberEtc": "Dirección, número, etc.",
    "postalCode": "Código postal",
    "poBoxOrFullAddress": "Apartado postal o dirección completa",
    "payment": "Pago",
    "receivePaymentsVia": "Recibir pagos por",
    "paymentTypeStripe": "Stripe",
    "paymentTypeAth": "ATH",
    "athPhoneNumberLabel": "Número de teléfono ATH",
    "selectPaymentType": "Seleccionar tipo de pago",
    "choosePaymentMethod": "Elige cómo deseas pagar",
    "athPaymentRequest": "Solicitud de pago ATH",
    "athEnterPhoneNumber": "Ingresa el número de teléfono para enviar la solicitud de autorización de pago ATH",
    "athPhonePlaceholder": "ej. 5613305493",
    "stripeSwitchWarningTitle": "Cambio a Stripe",
    "stripeSwitchWarningHeading": "Se requiere incorporación a Stripe",
    "stripeSwitchWarningMessage": "Para recibir pagos por Stripe, debes completar la incorporación a Stripe. Puedes iniciarla desde la opción Incorporación de Stripe en la barra lateral. Puedes guardar este cambio ahora, pero los pagos solo funcionarán después de completar la incorporación.",
    "athPhoneInvalid": "Por favor ingresa un número de teléfono válido",
    "athPhoneNotAthAccount": "Este número de teléfono no está registrado en ATH Móvil",
    "enterDescription": "Ingresa tu descripción",
    "about": "Acerca de",
    "updateProfile": "Actualizar perfil",
    "ageConfirmationCheckboxLabel": "Confirmo que soy mayor de 18 años y que cumplo con los requisitos legales para ofrecer servicios a través de JANDI.",
    "ageConfirmationRequired": "Debes confirmar que eres mayor de 18 años para actualizar tu perfil.",
    "changePassword": "Cambiar contraseña",
    "currentPassword": "Contraseña actual",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirmar contraseña",
    "enterCurrentPassword": "Ingresa tu contraseña actual",
    "enterNewPassword": "Ingresa tu nueva contraseña",
    "confirmNewPassword": "Confirma tu nueva contraseña",
    "save": "Guardar",
    "uploadLimit": "Tamaño Max: 1MB, Extensiones: .pdf",
    "uploadCertificate": "Subir Certificado",
    "uploadDocument": "Subir documento",
    "pleaseSelectPdf": "Por favor selecciona un archivo PDF para subir.",
    "deleteCertificationConfirmTitle": "Eliminar documento",
    "deleteCertificationConfirmMessage": "¿Estás seguro de que deseas eliminar este documento? Esta acción no se puede deshacer.",
    "certificationDeleted": "Documento eliminado correctamente.",
    "myCertifications": "Mis certificaciones",
    "completeYourProfile": "Completa Tu Perfil",
    "completeClientProfileMessage": "Por favor proporciona tu número de teléfono para continuar.",
    "completeWorkerProfileMessage": "Por favor proporciona tu número de teléfono para continuar.",
    "pleaseEnterValidPhone": "Por favor ingresa un número de teléfono válido",
    "pleaseSelectServiceCategory": "Por favor selecciona una categoría de servicio",
    "profileUpdatedSuccessfully": "Perfil actualizado exitosamente",
    "errorUpdatingProfile": "Error al actualizar el perfil. Por favor intenta de nuevo.",
    "updating": "Actualizando...",
    "continue": "Continuar",
    "completeProfileMessage": "Por favor completa tu Ciudad, Servicios, Regiones y Descripción en la pestaña \"Región y Servicios\" para acceder a todas las configuraciones.",
    "profileIncomplete": "Perfil Incompleto,por favor completa tu perfil en orden para mostrarlo a los clientes",
    "missingFieldsMessage": "Faltan los siguientes campos requeridos:",
    "actions": "Acciones",
    "certification": "Certificación",
    "document": "Documento",
    "skills": "Habilidades (Skills)",
    "noMessagesYet": "Aún no hay mensajes",
    "startConversation": "Inicia una conversación enviando una propuesta o respondiendo a una invitación de trabajo.",
    "startAConversation": "Inicia una conversación",
    "writeAMessage": "Escribe un mensaje...",
    "sendMessageToUser": "Envía un mensaje a",
    "startChating":"para comenzar a chatear.",
    "stripeDashboard":"Panel de control de Stripe",
    "sentAgo": "Enviado hace",
    "second": "segundo",
    "minute": "Minuto",
    "hour": "Hora",
    "day": "Día",
    "seconds": "segundos",
    "minutes": "Minutos",
    "hours": "Horas",
    "days": "Días",
    "justNow": "un momento",
    "pay_now": "Pagar ahora",
    "payment_summary": "Confirmar y pagar",
    "job_details": "Detalles del trabajo",
    "service_provider": "Propuesta de",
    "service_name": "Servicio",
    "date": "Fecha acordada",
    "status": "Estado",
     "stripeOnbaord":"Incorporación de Stripe",
    "awaiting_payment": "En espera de pago",
    "payment_breakdown": "Desglose del pago",
    "budget": "Tu cotización",
    "platform_fee": "Comisión de la plataforma",
    "stripe_fee": "Comisión de Stripe",
    "total_charge": "Cargo total",
    "transparent_fees_note": "Todas las tarifas son transparentes y se muestran claramente",
    "voucher_code": "Código de voucher",
    "apply_voucher": "Aplicar",
    "clear_voucher_code": "Borrar código",
    "voucher_discount": "Descuento",
    "voucher_invalid": "Código de voucher inválido",
    "voucher_apply_help": "Ingresa un código de voucher y haz clic en Aplicar para previsualizar el total con descuento. El descuento solo reduce el cargo de servicio.",
    "voucher_apply_required": "Haz clic en Aplicar para previsualizar el total del voucher antes de pagar.",
    "voucher_fee_was_now": "El cargo de servicio era ${{before}}, ahora ${{after}} ({{pct}}%)",
    "voucher_will_be_applied": "El voucher {{code}} se aplicará al enviar",
    "platform_fee_discount_applied": "Se aplicó un descuento en la comisión de la plataforma: ${{amount}}",
    "platform_fee_after_voucher": "Comisión de plataforma después del voucher: ${{amount}} ({{pct}}%)",
    "my_vouchers": "Mis vouchers",
    "my_vouchers_intro": "Vouchers asignados a tu cuenta por Jandi. Úsalos al pagar o al enviar una propuesta.",
    "my_vouchers_empty": "Aún no tienes vouchers asignados.",
    "my_vouchers_load_error": "No se pudieron cargar tus vouchers.",
    "my_vouchers_validity": "Vigencia",
    "my_vouchers_audience": "Para",
    "my_vouchers_audience_client": "Clientes",
    "my_vouchers_audience_provider": "Proveedores",
    "my_vouchers_status_active": "Activo",
    "my_vouchers_status_inactive": "Inactivo",
    "my_vouchers_status_expired": "Expirado",
    "my_vouchers_status_upcoming": "Próximo",
    "my_vouchers_use_assigned": "Tus vouchers asignados (toca para aplicar):",
    "provider_voucher_section_title": "Código promo / voucher (opcional)",
    "provider_voucher_help": "Ingresa un código de voucher de proveedor para reducir tu comisión de plataforma. El código se valida al enviar la propuesta.",
    "provider_voucher_help_apply": "Ingresa el presupuesto (o tarifa × horas) y luego Aplicar para validar el voucher y ver la comisión reducida.",
    "provider_voucher_placeholder": "ej. PRO10",
    "provider_voucher_need_budget": "Ingresa el presupuesto de la propuesta (o tarifa por hora y horas) antes de aplicar un voucher.",
    "provider_voucher_reapply_budget": "El presupuesto cambió después de aplicar el voucher. Aplica el código de nuevo.",
    "provider_voucher_review_note": "El código {{code}} se validará al enviar. Si es válido, tu comisión de plataforma se reduce y aumentan tus ganancias.",
    "provider_platform_fee_full": "Comisión de plataforma (completa)",
    "provider_earnings_before_voucher": "Ganancias antes del voucher",
    "serviceChargeBeforeDiscount": "Cargo de servicio antes del descuento",
    "platformFeeBeforeDiscount": "Comisión de plataforma antes del descuento",
    "serviceChargeAfterDiscount": "Cargo de servicio después del descuento",
    "platformFeeAfterDiscount": "Comisión de plataforma después del descuento",
    "paymentAuthTitle": "🔐 Autorización del pago",
    "paymentAuthDescription": "Tu pago está protegido. Solo se libera al proveedor cuando confirmas que el servicio fue completado.",
    "paymentAuthOnCompletion": "El monto será autorizado ahora y procesado al completarse el servicio.",
    "close": "Cerrar",
    "confirm_payment": "Confirmar y autorizar pago",
    "payment_info": "Información de pago",
    "postServiceModalTitle": "✅ ¿Recibiste el servicio?",
    "postServiceModalDescription": "Para cerrar el proceso y liberar el pago, debes marcar el servicio como completado dentro de la plataforma.",
    "postServiceModalMarkCompleted": "Marcar como completado",
    "postServiceModalReportIssue": "Reportar inconveniente",
    "provider_will_receive": "El proveedor recibirá",
    "start_work": "Empezar a trabajar",
    "worker_on_the_way": "El trabajador está en camino",
    "mark_as_arrived": "Marcar como llegado",
    "begin_job": "Iniciar trabajo",
    "finish_job": "Finalizar trabajo",
    "confirm_start_job": "¿Estás seguro de que quieres start job?",
    "irreversible_action": "Esta acción no se puede deshacer.",
    "confirm_release_payment": "¿Estás seguro de que quieres release payment?",
    "view_proposals": "Ver propuestas",
    "clear": "Limpiar",
    "view_details": "Ver detalles",
    "completed": "Completado",
    "enter_proposal_title": "Ingresa el título de la propuesta",
    "select_payment_type": "Seleccionar tipo de pago",
    "hourly": "Por hora",
    "fixed": "Fija",
    "title": "Título",
    "location": "Ubicación",
    "search_location": "Buscar un lugar",
    "search": "Buscar",
    "no_options": "Sin opciones",
    "select_start_date_time": "¿Cuándo lo necesitas?",
    "end_date_time": "Fecha y hora de finalización",
    "select_end_date_time": "Selecciona fecha y hora de finalización",
    "urgency": "¿Qué tan urgente es?",
    "low": "Flexible (puede esperar días)",
    "medium": "Esta semana",
    "high": "Hoy mismo",
    "upload_or_drag_image": "Adjunta una foto",
    "enter_total_budget": "Escribe el precio que cobrarías por este servicio",
    "enter_hourly_rate": "Ingresa tu tarifa por hora (USD)",
    "enter_total_hours": "Ingresa las horas estimadas para este trabajo",
    "enter_description": "Describe brevemente tu propuesta",
    "o":"O",
    "selectLocation": "Seleccionar ubicación",
    "dragLocation":"Arrastra el marcador para seleccionar la ubicación",
    "saveLocation":"Guardar ubicación",
    "selectTheChat":"Selecciona un chat para empezar a conversar",
    "chats":"Charlas",
    "selectServices": "Seleccione uno o varios servicios",
    "selectRegions": "Seleccione una o varias regiones/municipios",
    "selectAvailability": "Seleccionar disponibilidad",
    "enterEmail": "Introduce tu correo electrónico",
    "enterMessage": "Escribe tu mensaje aquí",
    "fixedRate": "Tarifa fija",
    "reviewProposalMessage": "Por favor revisa tu propuesta cuidadosamente antes de enviarla.",
    "proposalNote": "Una vez enviada, no podrás editar los detalles de la propuesta, incluidos tarifas, tiempos o cualquier otra información.",
    "review": "Review",
    "reviews": "Reviews",
    "helloJandi": "¡Hola! Soy Jandi",
    "wantToKnowHow": "¿Quieres saber cómo funciona nuestra plataforma?",
    "tellUsWhatYouNeed": "Cuéntanos qué necesitas o qué puedes ofrecer",
    "stepOne": "Ya sea que busques ayuda o quieras ofrecer un servicio, el primer paso es contarnos qué necesitas o qué sabes hacer.",
    "findWhatYouNeed": "Encuentra lo que necesitas",
    "personalizedOptions": "Recibirás opciones personalizadas: clientes que necesitan tu servicio o profesionales listos para ayudarte.",
    "organizeYourService": "Organiza tu servicio",
    "organizeDetails": "Acuerda horarios, precios y detalles. Nosotros te acompañamos para que todo sea fácil, seguro y claro.",
    "how_it_works_title": "Cómo funciona",
    "how_it_works_subtitle": "Encuentra tu Jandi, agenda y resuelve tu servicio del hogar sin complicaciones.",
    "how_it_works_step_1": "Elige tu Jandi por precio, experiencia y reseñas",
    "how_it_works_step_2": "Agenda para hoy mismo si quieres",
    "how_it_works_step_3": "Chatea, paga y evalúa — todo en un solo lugar",
    "electrician": "Electricista",
    "handyman": "Handyman",
    "tutor": "Tutor",
    "caregiver": "Cuidador",
    "groomer": "Groomer",
    "login": "Ingresar",
    "resetPassword": "Restablecer contraseña",
    "enterNewPassword": "Introducir nueva contraseña",
    "confirmNewPassword": "Confirmar nueva contraseña",
    "confirmPassword": "Confirmar contraseña",
    "netAmount": "Monto neto",
    "markOnMyWay": "Marcar en camino",
    "payNow": "Pagar ahora",
    "workersConfirmationPending": "Confirmación del trabajador pendiente",
    "markAsReached": "Confirmar llegada",
    "connectionStatus": "Estado de la conexión",
    "connected": "Conectado",
    "reconnecting": "Reconectando",
    "myStatus": "Mi estado",
    "clientStatus": "Estado del cliente",
    "professionalStatus": "Estado del profesional",
    "sharingLocation": "Compartiendo ubicación",
    "liveLocation": "Ubicación en tiempo real",
    "disconnected": "Desconectado",
    "notSharingLocations": "No compartiendo ubicaciones",
    "waitingForLocationData": "Esperando datos de ubicación",
    "no": "No",
    "yes": "Sí",
    "rejected":"rechazado",
    "awaitingWorkersAcceptance": "En espera de la aceptación del trabajador",
    "workerIsOnTheWay": "El proveedor está en camino",
    'clientwait':"Esperando respuesta del cliente",
    "finishJob": "Finalizar trabajo",
    "releaseFunds": "Liberar fondos",
    "jobCompleted": "Trabajo completado",
    "jobCancelled": "Trabajo cancelado",
    "jobRejected": "Trabajo rechazado",
    "refunded": "Reembolsado",
    "awaitingPayment": "En espera de pago",
    "reached": "El proveedor ha llegado al lugar del servicio",
    "jobFinished": "Trabajo finalizado",
    "successfullyCompleted": "El proveedor marcó el trabajo como completado",
    "cancelled": "Cancelado",
    "acceptReject": "Aceptar/Rechazar",
    "confirmJob": "Confirmar trabajo",
    "submitForCompletion": "Enviar para finalización",
    "applicationRejected": "Solicitud rechazada",
    "applicationWithdrawn": "Solicitud retirada",
    "confirmAction": "¿Confirmar acción?",
    "creatingJob":"Creando trabajo...",
    "rateExperience":"¿Cómo fue tu experiencia?",
    "leaveFeedback":"Tu evaluación ayuda a otros clientes a elegir con confianza.",
    "submitReview":"Enviar evaluación",
    "characters": "Caracteres",
    "cancel": "Cancelar",
    "write": "Escribir",
    "other":"Otros",
    "Type":"Tipo",
    "of":"de",
    "legalAgreements":"Acuerdos legales",
    "privacyPolicy":"Política de privacidad",
    "termOfUse":"Términos de uso",
    "textMessagePolicy":"Política de Mensajes de Texto",
    "confimation":"Aceptar nuestra",
    "and":"y",
    "smsOptInCheckboxLabel": "Acepto recibir mensajes SMS automatizados relacionados con mi cuenta y servicios en JANDI. Frecuencia variable. STOP para cancelar. Pueden aplicar tarifas según su proveedor móvil.",
    "smsOptInHelperText": "Los mensajes SMS se utilizan únicamente para notificaciones del servicio como solicitudes, mensajes del chat, recordatorios de citas, cambios de estatus o cancelaciones.",
    "settingsSmsNotificationsLabel": "Recibir notificaciones por SMS",
    "settingsSmsNotificationsHelper": "Puedes desactivarlas en cualquier momento. Responde STOP a cualquier mensaje para cancelar.",
    "settingsSmsNotificationsLabel": "Recibir notificaciones por SMS",
    "settingsSmsNotificationsHelper": "Puedes desactivarlas en cualquier momento. Responde STOP a cualquier mensaje para cancelar.",
    "noProposalsYet":"No hay propuestas disponibles por el momento",
    "city": "Ciudad",
    "physicalAddress": "Dirección Física",
    "postalAddress": "Dirección Postal",
    "servicesYouWouldProvide": "Servicios que prestaría",
    "whatCanYouDo": "¿Qué puedes hacer? (Selecciona tus habilidades)",
    "enterFullPostalAddress": "Ingresa tu dirección postal completa. Puedes usar un P.O. Box o tu dirección residencial. (número + calle + ciudad + PR + ZIP)",
    "includeStreetOrHighway": "Incluye número de carretera o número de calle si aplica.",
    "continue": "Continuar",
    "exampleAddress": "Ej: Carretera 123, Km 4.5, Barrio Pueblo",
    "streetOrHighwayNumber": "Número de Calle o Carretera (si aplica)",
    "zipCode": "Código Postal",
    "examplePOBox": "Ej: P.O. Box 1234, San Juan, PR, 00901",
    "uploadLogoIfAny": "Si tienes un logo puedes subirlo aquí",
    "tellUsAboutService": "Cuentanos sobre el servicio que ofreces",
    "exampleExperience": "Soy un profesional con mas de 5 años de experiencia en...",
    "back": "Volver",
    "finish": "Finalizar",
    "loadingServices": "Cargando servicios",
      'requestService':"Solicitar servicio",
    "noDescriptionAvailable":"No hay descripción disponible",
    "skillsRequired":"Habilidades requeridas",
    "availableProviders":"Proveedores disponibles",
      'metadataTags':'Etiquetas de metadatos',
     "StripeOnboardingInComplete":"Se requiere incorporación de Stripe",
  "YoourStripeOnboardingInComplete":"Tu incorporación a Stripe está incompleta.",
  "CompleteOnboarding":"Complete el proceso de incorporación para aceptar trabajos y recibir pagos.",
   "Close":"cerca",
   "descriptionofRequestedService":"Describe brevemente lo que necesitas",
    "serviceLocation":"¿Dónde necesitas el servicio?",
    "estimatedBudget":"¿Cuál es tu presupuesto aproximado? ",
    'optional':"opcional",
    "selectBudgetRange":"Seleccionar rango",
    "mustLoginToSendProposal":"Debe iniciar sesión para enviar la solicitud de cotización.",
    "DateTextHelp":"Indica una fecha tentativa. Podrás acordar la fecha y hora final con el proveedor",
    "budgetHelpText":"El precio final se acuerda con el proveedor antes de comenzar.",
    "SVerification":"Verificación exitosa",
    "SVerified":"Tu cuenta ha sido verificada correctamente.",
    "EVerification":"Error de verificación",
    "EVerified":"El código de verificación es inválido o ha expirado.",
    "signupConfirmation_provider_primaryButton":"Completar mi perfil",
    "signupConfirmation_provider_title":"¡Bienvenido a jandi!",
    "signupConfirmation_provider_intro":"Tu solicitud fue recibida. Nuestro equipo revisará tu perfil en las próximas 24 a 48 horas. Te notificaremos cuando estés activo y listo para recibir solicitudes.",
    "signupConfirmation_provider_body":"Mientras tanto, asegúrate de tener tu perfil completo con foto y descripción - eso acelera la validación.",
    "signupConfirmation_provider_footer":"Puerto Rico tiene talento. Queremos que se quede y que esté siempre a la mano.",
    "signupConfirmation_client_title":"¡Ya eres parte de jandi!",
    "signupConfirmation_client_intro":"Tu cuenta ha sido creada. verifica tu correo electrónico y luego puedes buscar proveedores disponibles en tu área y resolver lo que necesitas - rápido, fácil y con respaldo.",
    "selectRoleContinue":"Selecciona tu rol para continuar",
    "workOwnPace":"Trabaja a tu ritmo. Tú decides cuándo y cómo",
  ...whatMovesUsEs,
  ...faqEs,
  ...termOfUseEs,
  ...privacyPolicyEs,
  ...textMessagePolicyEs,
  ...legalAgreementsContactEs,
};